import { Component, OnInit, OnDestroy } from '@angular/core';
import { RanchService } from '../../service';
import { UpdateService } from '../../../../services/update.service';
import { Router } from '@angular/router';

import { IRanchPermissions, IRanch } from '../../interfaces';
import { eModalFormViews } from '../../../../interfaces/constants';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { IReactiveFormComponent } from '../../../shared/interfaces';
import { FormGroup, AbstractControl } from '@angular/forms';
import { BaseDialog } from '../../../shared/dialogs/base-dialog';
import { SharedUpdateService } from '../../../shared/dialogs/update.service';
import { PlantingService } from '../../../planting-settings/service';

@Component({
	moduleId: module.id,
	selector: 'ranch-modal',
	templateUrl: 'main.html',
	styleUrls: ['main.scss']
})

export class RanchDialog extends BaseDialog implements OnInit, OnDestroy, IReactiveFormComponent {
	public isSaving = false;
	protected _subscriptions$: Subject<boolean>;

	public view: eModalFormViews = eModalFormViews.FORM;
	public modalFormViews = eModalFormViews;
	public permissions: IRanchPermissions;

	public form: FormGroup;
	public fields = {
		Coordinates: 'Coordinates',
		Name: 'Name',
		Acres: 'Acres',
		SpatialETAvailable: 'SpatialETAvailable',
		WeatherAPI_Id: 'WeatherAPI_Id'
	}

	public get f(): { [key: string]: AbstractControl } {
		if (!this.form) {
			return null;
		} else {
			return this.form.controls;
		}
	} //

	constructor(
		private dialog: MatDialog,
		private dialogref: MatDialogRef<RanchDialog>,
		private ranchService: RanchService,
		private _plantingService: PlantingService,
		private updateService: UpdateService,
		private sharedUpdateService: SharedUpdateService,
		private router: Router) {

		super(dialog, dialogref, sharedUpdateService);

		this._subscriptions$ = new Subject();
		this.dialogref.disableClose = true;
	}

	ngOnInit(): void {
		this.permissions = this.updateService.currentPermissions;
		this._configureDeleteConfirmationText();
		super.ngOnInit();

		this.updateService.RanchPlantingsPermissions$.pipe(takeUntil(this._subscriptions$)).subscribe(permissions => {
			this.permissions = permissions;
		});
	}

	ngOnDestroy(): void {
		if (!this._subscriptions$) {
			return;
		}

		this._subscriptions$.next(true);
		this._subscriptions$.complete();
	}

	public delete(): void {
		this.ranchService.deleteRanch(this.updateService.currentRanchId)
			.then(() => {
				this.sharedUpdateService.deleteComplete();
				this.close();
				this.router.navigate(['MyDashboard']);
			});
	}

	protected preventClose(): boolean {
		return false;
	}

	public submit(form: FormGroup): void {
		this.form = form;
		this.edit();
	}

	public setForm(form: FormGroup): void {
		this.form = form;
	}

	private _clear(): void {
		this.view = eModalFormViews.FORM;
	}

	private _configureDeleteConfirmationText(): void {
		this._deleteConfirmationData = {
			objectName: 'Ranch',
			specificName: null,
			additionalMessage: 'Are you sure you want to delete this ranch?'
		};
	}

	public edit(): void {

		// Update the ranches list when ranch is updated - ideally we just copy over data, and ideally we only have
		// one data storage here to check, not two

		let ranch: IRanch;
		let ranchFavorite: IRanch;

		// update ranch data in the my ranches and favorites cache
		ranch = this.ranchService.findRanchByGuid(this.ranchService.ranches.myRanches,
			this.updateService.currentRanchId);

		if (ranch !== null) {
			ranch.Name = this.form.get(this.fields.Name).value;
			ranch.Coordinates = this.form.get(this.fields.Coordinates).value;
			ranch.Acres = this.form.get(this.fields.Acres).value;
		} else {
			ranch = {
				Name: this.form.get(this.fields.Name).value,
				Coordinates: this.form.get(this.fields.Coordinates).value,
				Acres: this.form.get(this.fields.Acres).value,
				Id: null,
			}
		}

		ranchFavorite = this.ranchService.findRanchByGuid(this.ranchService.ranches.favorites,
			this.updateService.currentRanchId);

		if (ranchFavorite !== null) {
			ranchFavorite.Name = this.form.get(this.fields.Name).value;
			ranchFavorite.Coordinates = this.form.get(this.fields.Coordinates).value;
			ranchFavorite.Acres = this.form.get(this.fields.Acres).value;
		}

		if (this.isSaving) {
			return;
		}

		this.isSaving = true;

		this.ranchService.editRanchBasicInfo(this.form.value)
		.then(() => {
			this.ranchService.getRanchBasicInfo().then((res) => {
				ranch.WeatherAPI_Id = res.WeatherAPI_Id;
				this.isSaving = false;
				this.updateService.setUpdatedRanches('ranch edited');
				this.updateService.setUpdatedRanch(ranch);
				this.dialogref.close();
				this._clear();
			});
		});
	}

}
